<template>
    <div class="actions">
        <div
            v-for="(action, i) in props.exported.actions"
            :key="i"
            >
            <vm-action-button
                :key="`button-`+i"
                v-if="props.row[action.condition.field]==action.condition.value"
                :class="{ 'ml-1': i !== 0 }"
                :icon="action.icon"
                :elevation="0"
                primaryColor="rgba(0,0,0,0)"
                accentColor="rgba(var(--default-color),0.8)"
                :isSmall="true"
                @click="action.callback(props.row)"
            >
            </vm-action-button>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    props: ['exported', 'row', 'field'],
    // eslint-disable-next-line
    setup(props: any) {
        return {
            props,
        };
    },
};
</script>

<style scoped>
.update-delete {
    display: flex;
}

.actions {
    display: flex; 
    flex-direction: row;
}
</style>
